import { useNavigate, useRouteError } from 'react-router-dom';

const errors = {
  404: {
    msg: 'صفحه مورد نظر پیدا نشد',
    img: '/general-empty-list.png',
  },
  500: {
    msg: 'خطایی رخ داد',
    img: '/assets/not-found.svg',
  },
};

export default function SSRErrorBoundary() {
  const navigate = useNavigate();
  const error: any = useRouteError();
  const { msg, img } = errors[error?.status] ?? errors[500];

  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100vw',
          height: '100vh',
          fontFamily: 'Yekan',
        }}
      >
        <img src={img} alt={msg} style={{ maxWidth: 300 }} />
        <p
          style={{
            fontWeight: 'bold',
            marginTop: 16,
            marginBottom: 16,
            fontSize: 20,
          }}
        >
          {msg}
        </p>
        <button
          type="button"
          style={{
            minWidth: 150,
            outline: 'none',
            color: 'white',
            backgroundColor: 'black',
            padding: '8px 16px',
            borderRadius: 8,
            fontFamily: 'Yekan',
            boxShadow: 'none',
            border: 'none',
          }}
          onClick={() => {
            navigate('/', { replace: true });
          }}
        >
          بازگشت به صفحه اصلی
        </button>
      </div>
    </div>
  );
}
